<template>
  <BaseLayout title="Models / API">
    <b-tabs v-model="currentTab">
      <b-tab
        active
        title="Modules"
      >
        <ServicesList
          :headers="headers"
          :services="services.filter((s) => s.category === 'Module')"
        />
      </b-tab>
      <b-tab title="Tools">
        <ServicesList
          :headers="headers"
          :services="services.filter((s) => s.category === 'Tools')"
        />
      </b-tab>
      <b-tab title="Models">
        <ServicesList
          :headers="headers"
          :services="services.filter((s) => s.category === 'Model')"
        />
      </b-tab>
      <b-tab title="Data">
        <ServicesList
          :headers="headersData"
          :services="dataSources"
        />
      </b-tab>
    </b-tabs>
  </BaseLayout>
</template>

<script>
import FeaturesBase from '@/components/FeaturesBase'
import { mapGetters } from 'vuex'
import moment from 'moment'
import ServicesList from '@/components/ServicesList.vue'
import { SERVICES_URL } from './main'
import BaseLayout from '@/layouts/BaseLayout.vue'

export default {
  components: { ServicesList, BaseLayout },
  mixins: [FeaturesBase],

  data() {
    return {
      services: [],
      currentTab: 0,
      dateFormat: 'YYYY-MM-DD HH:mm',
      headers: [
        { text: 'Name', value: 'title' },
        { text: 'API', value: 'api', sortable: false },
        { text: 'Available', value: 'is_available', width: '20px' },
        { text: 'Build date', value: 'build_date', width: '150px' },
        { text: 'Description', value: 'description', sortable: false },
      ],
      headersData: [
        { text: 'Data Source', value: 'title' },
        {
          text: 'Snapshot date or Version',
          value: 'build_date',
          width: '150px',
        },
        { text: 'Description', value: 'description', sortable: false },
      ],
    }
  },
  created() {
    this.fetchCimComponentInfo()
  },
  methods: {
    async fetchCimComponentInfo() {
      try {
        const response = await this.$axios.get(`${SERVICES_URL}/cim_component_info`)
        this.services = response.data
      } catch (error) {
        console.error('Error fetching Cim component info:', error)
      }
    },
    formatDate(value) {
      const date = moment(value)
      if (date.isValid()) {
        return date.format(this.dateFormat)
      } else {
        return null
      }
    },
    getBuildDateStr(module) {
      const buildDate = this.getBuildDates(module)
      return buildDate ? this.formatDate(buildDate) : ''
    },
  },
  computed: {
    ...mapGetters(['getBuildDates', 'feature']),
    dataSources() {
      return this.services.filter((s) => s.category === 'Data')
    },
  },
}
</script>
